// Modules
import * as Yup from 'yup'

export const CreatePasswordSchema = Yup.object().shape({
    password: Yup.string()
        .required('Campo obrigatório')
        .test(
            'password min-length',
            'Para continuar, sua senha precisa ter no mínimo 8 caracteres',
            (value: string): boolean => Boolean(value) && value.length >= 8,
        )
        .test(
            'password max-length',
            'Você atingiu o limite de 40 caracteres, diminua para continuar',
            (value: string): boolean => Boolean(value) && value.length <= 40,
        ),
})
